export default __webpack_public_path__ + "static/media/hde_logo.317c436d.svg";